import OTPVerificationForm from "../../components/User/OTPVerification";

const OTPVerification = () => {
    return(
        <OTPVerificationForm />
    )
}

export default OTPVerification;